<template>
  <div class="h-100 d-flex flex-column">
    <div class="container text-center">
      <div class="row pt-4 pb-3">
        <div class="col-sm">
          <svg width="88px" height="77px" viewBox="0 0 88 77" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="ускорение" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Desktop_08" transform="translate(-436.000000, -363.000000)" stroke="#FFFFFF" stroke-width="5">
                <g id="Group" transform="translate(323.000000, 368.000000)">
                  <g id="!" transform="translate(118.000000, 0.000000)">
                    <polygon id="Triangle" points="39.3037975 3.11209392e-14 78.6075949 69 0 69"></polygon>
                    <line x1="39.7405063" y1="49.7848101" x2="39.7405063" y2="20.0886076" id="Path-3"></line>
                    <line x1="39.7405063" y1="58.9556962" x2="39.7405063" y2="55.0253165" id="Path-3"></line>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-sm">
          <h1>Ошибка</h1>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm">
          <h3>Не удалось завершить оплату!</h3>
        </div>
      </div>
    </div>
    <button type="button" @click="$router.push('/')" class="btn btn-light btn-own mt-auto mb-4 align-self-center ">Вернуться на главную</button>
  </div>
</template>
<script>

export default {
  name: 'FailPayment',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
